<template>
    <vs-row>
        <br><br><br><br><br><br><br><br><br>
        <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <h2 vs-align="center">Welcome to Global API System</h2>
        </vs-col>
        <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem cupiditate, dignissimos dolorum eos error eum facere hic illum iure, magni quam repellat reprehenderit rerum vel voluptas voluptates voluptatibus.</p>
        </vs-col>
        <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <img style="top: 10px;position: relative;" src="@/assets/images/logo/home.png">
        </vs-col>
    </vs-row>
</template>


<script>
    export default {
        data() {
            return {}
        },
        created() {
            this.setBreadCrumbsItems();
        },
        methods: {
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Dashboard',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            }
        }
    }
</script>